export const mapID = "address-map";
export const elementWrapperID = "address-wrapper";
export const inputID = "address-input";

export const DEFAULT_ZOOM = 5;
export const SEARCH_MAP_ZOOM = 10;
export const DEFAULT_MAP_POSITION = {
  lat: 37.09024,
  lng: -95.712891,
};

export interface ILocationData {
  lat: number;
  lng: number;
}

export interface IAddressData extends ILocationData {
  placeName: string;
  apartmentNo?: string;
}

export const getInitialLocation = (
  initialAddressData: IAddressData,
): IAddressData => {
  if (initialAddressData?.placeName) {
    return initialAddressData;
  }
  return {
    ...DEFAULT_MAP_POSITION,
    placeName: "USA",
  };
};
